<template>
    <div>
        <visit-modal 
            ref="visitForm" 
            id="visit-form" 
            :title="titleForm" 
            :is-loading="isLoadingGrid" 
            :doctors="doctors"
            @on-create="handleCreate" 
        />

        <bita-breadcrumb :items="breadCrumbs" />

        <div class="wrapper wrapper-content animated fadeInRight">
            <bita-ibox :is-loading="isLoadingGrid">
                <div slot="body">
                    
                    <!-- بخش فیلترها -->
                    <div class="row mb-4 bg-light p-3 rounded border">
                        <div class="col-12 mb-2"><strong>فیلتر نوبت‌ها:</strong></div>
                        <bita-select
                            name="filter_doctor"
                            label="انتخاب پزشک"
                            :validation-container-class="col4"
                            :data-source="doctors"
                            data-text-field="name"
                            data-value-field="id"
                            v-model="filters.doctor_id"
                        />
                        <bita-datepicker
                            type="date"
                            name="filter_date"
                            label="تاریخ"
                            :validation-container-class="col4"
                            input-class="form-control"
                            v-model="filters.date"
                            format="YYYY/MM/DD"
                            display-format="jYYYY/jMM/jDD"
                        />
                        <div class="col-lg-4 d-flex align-items-end mb-3">
                            <bita-bootbutton type="info" title="جستجو" icon="fas fa-search" @click.native="loadData" />
                            <bita-bootbutton type="default" title="پاک کردن" class="mr-2" @click.native="clearFilters" />
                        </div>
                    </div>

                    <hr />

                    <bita-bootbutton 
                        type="primary" 
                        title="تولید نوبت جدید" 
                        icon="fas fa-plus-square" 
                        btn-width="200px"
                        @click.native="createVisits" 
                    />
                    <hr />

                    <bita-grid 
                        ref="grid" 
                        :columns="gridColumns" 
                        :read-data="readData" 
                        :page-size="pageSize"
                        :current-page="currentPage" 
                        :has-row-number="true" 
                        :grid-server-side="true"
                        :schema-total="'total'" 
                        :schema-data="'data'" 
                        :server-paging="true"
                        :batch="true" 
                    />
                </div>
            </bita-ibox>
        </div>
    </div>
</template>

<script>
import visitsApi from '../../../api/clinic/visitsApi';
import doctorsApi from '../../../api/clinic/doctorsApi';
import VisitModal from './components/VisitModal';

export default {
    components: { VisitModal },
    data() {
        return {
            col4: "col-lg-4",
            pageSize: 15,
            currentPage: 1,
            titleForm: '',
            isLoadingGrid: false,
            breadCrumbs: [
                { title: "صفحه اصلی", link: "/" },
                { title: "مدیریت نوبت‌ها", link: "/clinic/visits", active: true },
            ],
            doctors: [],
            filters: {
                doctor_id: "",
                date: "",
            }
        };
    },

    mounted() {
        this.loadDoctors();
    },

    computed: {
        gridColumns() {
            return [
                { 
                    field: "doctor", 
                    title: "نام پزشک", 
                    template: ({ doctor }) => doctor?.name || " - " 
                },
                { 
                    field: "date", 
                    title: "تاریخ", 
                    template: ({ date }) => this.$getJalaliDate(date) || " - " 
                },
                { 
                    field: "payment", 
                    title: "مبلغ ویزیت", 
                    template: ({ payment }) =>this.$thousandSeprator(this.$round(payment||0))  || " - " 
                },
                { 
                    field: "pre_paymnet", 
                    title: "پیش پرداخت", 
                    template: ({ pre_payment }) => this.$thousandSeprator(this.$round(pre_payment||0)) || " - " 
                },
                { 
                    field: "start_time", 
                    title: "ساعت شروع", 
                    template: ({ start_time }) => start_time ? start_time.substring(0, 5) : " - " 
                },
                { 
                    field: "end_time", 
                    title: "ساعت پایان", 
                    template: ({ end_time }) => end_time ? end_time.substring(0, 5) : " - " 
                },
                { 
                    field: "is_free", 
                    title: "وضعیت", 
                    template: ({ is_free }) => is_free 
                        ? '<span class="badge badge-success">آزاد</span>' 
                        : '<span class="badge badge-danger">رزرو شده</span>' 
                },
                { 
                    field: "user", 
                    title: "بیمار", 
                    template: ({ user }) => user ? (user.name || user.mobile) : " - " 
                },
                { title: "عملیات", command: this.gridCommands() },
            ];
        },
    },

    methods: {
        toggleModal() {
            this.$toggleModal("#visit-form");
        },

        loadDoctors() {
            // دریافت لیست پزشکان بدون صفحه بندی (یا تعداد بالا) برای دراپ‌داون‌ها
            doctorsApi.get({ page_size: 1000 }).then(({ data }) => {
                this.doctors = data.data.data || data.data || data;
            });
        },

        clearFilters() {
            this.filters.doctor_id = "";
            this.filters.date = "";
            this.loadData();
        },

        loadData() {
            this.$refs.grid.loadDataSource();
        },

        readData(e) {
            this.$resetGrid();
            this.pageSize = e.data.pageSize;
            this.currentPage = e.data.page;
            this.isLoadingGrid = true;

            const queryParams = {
                page_size: this.pageSize,
                page: this.currentPage,
                ...this.filters
            };

            visitsApi.get(queryParams)
                .then(({ data }) => {
                    e.success(data);
                })
                .catch(() => {
                    e.success([]);
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });
        },

        createVisits() {
            this.$refs.visitForm.reset();
            this.titleForm = "تولید خودکار نوبت پزشک";
            this.toggleModal();
        },

        handleCreate(data) {
            this.isLoadingGrid = true;
            visitsApi.create(data)
                .then(() => {
                    this.$izitoast("success", "عملیات موفق", "نوبت‌ها با موفقیت ایجاد شدند.");
                    this.toggleModal();
                    this.loadData();
                })
                .catch((err) => {
                    if(err.response && err.response.data && err.response.data.errors) {
                        this.$refs.visitForm.setErrors(err.response.data.errors);
                    } else if(err.response && err.response.data && err.response.data.message) {
                        this.$izitoast("error", "خطا", err.response.data.message);
                    }
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });
        },

        delete(e) {
            const data = this.$refs.grid.getSelectedGridRow(e);

            if(!data.is_free) {
                this.$izitoast("warning", "اخطار", "این نوبت رزرو شده است و قابل حذف نمی‌باشد.");
                return;
            }

            this.$alert("question", `آیا از حذف این نوبت در ساعت ${data.start_time} اطمینان دارید؟`, "", {
                confirmButtonText: "بله",
            }).then((result) => {
                if (result.value) {
                    this.isLoadingGrid = true;
                    visitsApi.delete(data.id)
                        .then((res) => {
                            this.$izitoast("success", "عملیات موفق", "نوبت حذف شد.");
                            this.loadData();
                        })
                        .finally(() => {
                            this.isLoadingGrid = false;
                            this.loadData();
                        });
                }
            });
        },

        gridCommands() {
            // در این سناریو به دلیل تولید انبوه، ویرایش تکی کاربرد کمی دارد و حذف کافیست
            return [
                { text: "delete", click: this.delete, template: this.gridButtons.delete },
            ];
        },
    },
};
</script>
